import SwiperCore, { Navigation } from 'swiper/core';
import Swiper from 'swiper';
import { Breakpoint } from '../../../types/breakpoint';
export default class TereaVariantsSlider {
    static $slider = $('.js__terea-variants-slider');
    static swiper;
    static options = {
        centeredSlides: true,
        slidesPerView: 1,
        centerInsufficientSlides: true,
        spaceBetween: 24,
        watchOverflow: false,
        allowTouchMove: false,
        breakpoints: {
            [Breakpoint.lg]: {
                slidesPerView: 6,
                spaceBetween: 0,
                centeredSlides: false,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    };
    static init() {
        if (!this.$slider.length) {
            return;
        }
        SwiperCore.use([Navigation]);
        this.swiper = new Swiper(this.$slider.get(0), this.options);
    }
}
